export const DropOffIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.31028 8.46869C3.15591 3.9458 7.50843 0.964613 12.0313 1.80992C16.554 2.65547 19.5356 7.00767 18.6904 11.5306C17.8449 16.0537 13.4924 19.0354 8.96944 18.19C4.44656 17.3444 1.46493 12.9918 2.31028 8.46869ZM5.22652 5.88689C4.58821 6.70403 4.12947 7.68111 3.92574 8.77073C3.24714 12.4019 5.64049 15.8957 9.27147 16.5745C11.2327 16.9411 13.1526 16.4099 14.6118 15.2731L5.22652 5.88689ZM11.7292 3.42482C9.76795 3.05828 7.84747 3.58926 6.38832 4.72625L15.7748 14.1124C16.413 13.2953 16.8713 12.3181 17.075 11.2286C17.7534 7.59751 15.3602 4.10358 11.7292 3.42482Z"
    />
  </svg>
);
